// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"654":"0dab956c","926":"39fe5c42"}[chunkId] + ".chunk.js";
};